import { Component } from '@angular/core';
import { Observable, map } from 'rxjs';
import { NAV_ITEMS, NavItem } from 'src/app/core/config/nav-items';
import { AuthService } from 'src/app/core/services/auth.service';
import { SidebarStateService } from 'src/app/core/services/sidebar-state.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  readonly collapsed$ = this.sidebarState.collapsed$;

  readonly visibleItems$: Observable<NavItem[]> = this.authService.currentUser$.pipe(
    map((user) => NAV_ITEMS.filter((item) => item.roles.some((role) => user?.roles.includes(role))))
  );

  constructor(private readonly sidebarState: SidebarStateService, private readonly authService: AuthService) {}

  toggle(): void {
    this.sidebarState.toggle();
  }
}
